import { ITeam } from "core-integration/src/store/teams/types";
import * as React from "react";
import styled from "styled-components";

const StyledShirt = styled.img`
  display: inline-block;
  margin: auto;
  vertical-align: middle;
`;

interface IProps {
  path: string;
  sizes: string;
  team?: ITeam;
}

type Props = IProps;

const Shirt: React.FC<Props> = ({ path, sizes, team }) => {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`
          ${path}-66.webp 66w,
          ${path}-110.webp 110w,
          ${path}-220.webp 220w
          `}
        sizes={sizes}
      />
      <StyledShirt
        src={`${path}-66.png`}
        srcSet={`
          ${path}-66.png 66w,
          ${path}-110.png 110w,
          ${path}-220.png 220w
          `}
        sizes={sizes}
        alt={team ? team.name : ""}
      />
    </picture>
  );
};

export default Shirt;
